import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoUber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 73 48"
    {...props}
  >
    <g
      fill="#010202"
      clipPath="url(#Logo_Uber_svg__a)"
    >
      <path d="M4.758 28.855a6.2 6.2 0 0 0 1.264 2.071 5.4 5.4 0 0 0 1.914 1.317q1.106.456 2.405.456 1.264 0 2.37-.474a5.8 5.8 0 0 0 1.931-1.334 6.05 6.05 0 0 0 1.282-2.054q.456-1.194.456-2.668V11h3.687v24.579h-3.651v-2.283a8.5 8.5 0 0 1-2.897 2.002Q11.85 36 9.919 36q-1.965 0-3.669-.685a8.6 8.6 0 0 1-2.949-1.948q-1.245-1.264-1.966-3.038t-.72-3.95V11h3.687v15.169q0 1.474.456 2.686M26.422 11v8.954a9.4 9.4 0 0 1 2.844-1.95q1.616-.719 3.512-.719 1.966 0 3.686.737a9.4 9.4 0 0 1 2.985 2.002 9.4 9.4 0 0 1 2.001 2.984 9.2 9.2 0 0 1 .738 3.652 9.05 9.05 0 0 1-.738 3.634 9.5 9.5 0 0 1-2.001 2.967 9.4 9.4 0 0 1-2.985 2.002 9.3 9.3 0 0 1-3.686.737q-1.895 0-3.53-.72a9.3 9.3 0 0 1-2.86-1.949v2.248h-3.512V11zm.404 18.083a6.1 6.1 0 0 0 1.317 1.966 6.4 6.4 0 0 0 1.966 1.334q1.124.492 2.423.492 1.264 0 2.387-.492a6.1 6.1 0 0 0 1.95-1.334 6.5 6.5 0 0 0 1.316-1.966q.492-1.125.491-2.423 0-1.3-.491-2.44a6.5 6.5 0 0 0-1.317-1.984q-.825-.842-1.949-1.317a6.1 6.1 0 0 0-2.387-.474q-1.264 0-2.388.474a6.1 6.1 0 0 0-1.966 1.317 6.3 6.3 0 0 0-1.334 1.984 6.1 6.1 0 0 0-.492 2.44q0 1.3.474 2.423M44.189 23.044a9.6 9.6 0 0 1 1.93-2.967 9 9 0 0 1 2.915-2.02q1.686-.736 3.652-.737 1.93 0 3.581.703a8.5 8.5 0 0 1 2.844 1.948 8.9 8.9 0 0 1 1.861 2.95q.667 1.703.667 3.704v1.159H47.069q.175 1.089.702 2.019t1.317 1.615a6 6 0 0 0 1.79 1.07 5.9 5.9 0 0 0 2.125.387q3.195 0 5.161-2.633l2.564 1.896a9.5 9.5 0 0 1-3.3 2.809q-1.967 1.018-4.425 1.018-2 0-3.74-.702a9.1 9.1 0 0 1-3.02-1.967 9.3 9.3 0 0 1-2.018-2.967q-.737-1.703-.737-3.704 0-1.896.702-3.581m4.933-1.387q-1.492 1.246-1.984 3.318h10.92q-.456-2.072-1.949-3.318-1.493-1.247-3.493-1.247-2.003 0-3.494 1.247M68.276 22.06q-1.124 1.23-1.124 3.336V35.58h-3.546V17.67h3.51v2.213a5 5 0 0 1 1.739-1.721q1.07-.633 2.546-.632h1.228v3.3h-1.474q-1.755 0-2.88 1.23" />
    </g>
    <defs>
      <clipPath id="Logo_Uber_svg__a">
        <path
          fill="#fff"
          d="M.615 0h72v48h-72z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoUber;
